module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18tSTBt/tc-custom/9781948742429.jpg?1733031584907",
      "alt": "This image is the cover for the book Under Purple Skies, Belt City Anthologies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Under Purple Skies, Belt City Anthologies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“The ultimate (literary) tour guide to the neighborhoods and wild places, history and politics, culture and cuisine, music and myths of the Twin Cities” (Benjamin Percy, author of "), _c('i', [_vm._v("The Wilding")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v(" In recent years, Minneapolis has become one of America’s literary powerhouses. With over fifty poems and essays, "), _c('i', [_vm._v("Under Purple Skies: The Minneapolis Anthology")]), _vm._v(" collects some of the most exciting work being done in, or about, Minneapolis and the Twin Cities area. The narratives delve into the complexities of Minneapolis life—with threads that stretch back not just to Scandinavia, but across the world."), _c('br'), _c('br'), _vm._v(" This volume’s contributors include Marlon James, Shannon Gibney, Kelly Barnhill, James Wright, and many more. Collectively, they have won, or been shortlisted for, the Newbery Award, the Man Booker Prize, the Pulitzer, the Caldecott Award, the National Book Award, the Minnesota Book Award, among other awards. The wide-ranging stories featured here include:  A tour through Prince’s Minneapolis  The story of the Metrodome’s demolition  A story of a Somali immigrant’s journey to Eden Prairie  Eating Halva on Lake Street \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frank Bures\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Belt Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0